/**
 * @generated SignedSource<<a9aaa7559a622acc5062840c46c1177c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbPricingGuidance_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowSiderailSoldPricingGuidance_viewer">;
  readonly " $fragmentType": "PdpRespSidebarBlurbPricingGuidance_viewer";
};
export type PdpRespSidebarBlurbPricingGuidance_viewer$key = {
  readonly " $data"?: PdpRespSidebarBlurbPricingGuidance_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbPricingGuidance_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbPricingGuidance_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowSiderailSoldPricingGuidance_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "443919cd1941206940466c80710d6892";

export default node;
